import { BOARD_CANVAS_ORDER_LOAD } from './boardConstants';

export const boardCanvasOrderLoad = ({ canvasOrder }) => ({
    type: BOARD_CANVAS_ORDER_LOAD,
    canvasOrder,
});
